// External tracking scripts URLs that should be excluded from Datadog tracking
export const EXCLUDED_FETCH_URLS = [
  'https://px.ads.linkedin.com/wa/',
  'https://analytics.google.com/g/collect',
  'https://region1.analytics.google.com/g/collect',
  'https://www.googletagmanager.com/',
  'https://connect.facebook.net/',
  'https://pagead2.googlesyndication.com/measurement/conversion',
  'https://tr.snapchat.com/config',
  'https://tr6.snapchat.com/p',
  'https://www.google.com/measurement/conversion',
  'https://api.segment.io/v1/i',
  'https://api.branch.io/v1/event',
  'https://y.clarity.ms/collect',
] as const
